<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="img-holder ion-text-right">
    <img src="assets/img/summary-success.svg" alt="summary-success.svg" class="animate__animated animate__bounceInRight animate__delay-1s">
  </div>
  <div class="the-content animate__animated animate__bounceInUp">
    <div class="thanks-holder ion-text-left">
      <h1>Gracias</h1>
      <p>Hemos recibido su pedido. </p>
    </div>

    <div class="order-details ion-padding-vertical">
      <ion-grid>
        <ion-row>
          <ion-col class="header-row" size="4">
            <p>No. Pedido</p>
          </ion-col>
          <ion-col class="values-row">
            <p> {{ idPedido }} </p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="header-row" size="4">
            <p>No. Cliente</p>
          </ion-col>
          <ion-col class="values-row">
            <p> {{ idCliente }} </p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="header-row" size="4">
            <p>Nombre</p>
          </ion-col>
          <ion-col class="values-row">
            <p>{{ cliente }}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="header-row" size="4">
            <p>Fecha entraga</p>
          </ion-col>
          <ion-col class="values-row">
            <p>{{  fechaEstimada | date }}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="header-row" size="4">
            <p>Dirección Entrega</p>
          </ion-col>
          <ion-col class="values-row">
            <p>{{ direccionSeleccionada }}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="header-row" size="4">
            <p>Total</p>
          </ion-col>
          <ion-col class="values-row">
            <p>L. {{ (totalSinDescuento - ( descuento*totalSinDescuento )) | number : '1.2-2' }}</p>
          </ion-col>
        </ion-row>
        <ion-row class="ion-hide">
          <ion-col class="header-row" size="4">
            <p>Estado</p>
          </ion-col>
          <ion-col class="values-row">
            <p>{{ estado }}</p>
          </ion-col>
        </ion-row>
      </ion-grid>
    </div>
  </div>
</ion-content>
<ion-footer class="ion-no-border ion-padding-horizontal">
  <ion-toolbar>
    <div class="btn-holder">
      <ion-button expand="block" shape="round" (click)="goStatus()">
        Ver estado del pedido!
      </ion-button>
    </div>

    <div class="btn-holder">
      <ion-button expand="block" shape="round" (click)="goHome()">
        Continuar comprando!
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
